import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "cr_cookie_consent";

export function getCookieConsent() {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => { if (!getCookieConsent()) setVisible(true); }, []);
  if (!visible) return null;
  const choose = (v) => {
    try { localStorage.setItem(KEY, v); } catch { /* private mode */ }
    setVisible(false);
    window.dispatchEvent(new Event("cr-consent"));
  };
  return (
    <div className="fixed bottom-2 inset-x-2 sm:left-1/2 sm:-translate-x-1/2 sm:inset-x-auto z-50 sm:w-[94%] sm:max-w-2xl" data-testid="cookie-banner">
      <div className="bg-[#1C1B1A] text-white rounded-[24px] p-4 sm:p-5 shadow-[0_18px_50px_rgba(28,27,26,0.35)] flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
        <p className="text-xs leading-relaxed text-white/80 flex-1">
          We use strictly necessary cookies to keep you signed in and secure, plus privacy-friendly aggregated analytics to
          improve CourierRadar. Full details in our{" "}
          <Link to="/p/privacy" className="underline underline-offset-2 text-white hover:text-[#F2D06B] transition-colors">Privacy Policy</Link>.
        </p>
        <div className="flex gap-2 shrink-0">
          <button data-testid="cookie-essential" onClick={() => choose("essential")}
            className="border border-white/25 hover:bg-white/10 text-white px-4 py-2 rounded-full text-xs font-semibold transition-all">Essential only</button>
          <button data-testid="cookie-accept" onClick={() => choose("all")}
            className="bg-[#F2D06B] hover:bg-[#EFCB68] text-[#1C1B1A] px-4 py-2 rounded-full text-xs font-semibold transition-all">Accept all</button>
        </div>
      </div>
    </div>
  );
}
